import BaseAPI from './BaseAPI';

// Costs logged against an appointment, under /costs.
class CostsAPI extends BaseAPI {
  constructor() { super('costs'); }

  // GET /costs/payees → { vendors: [...], staff: [...] }
  payees() { return this.get('/payees'); }

  // POST /costs/vendors { name, kind } → { vendor }
  addVendor(name, kind) { return this.post('/vendors', { body: { name, kind } }); }

  // POST /costs/invoices — multipart; returns { invoice: { idInvoice, ... } }
  uploadInvoice(bookId, file) {
    const form = new FormData();
    form.append('invoice', file);
    form.append('bookId', bookId);
    return this.post('/invoices', { body: form });
  }

  // GET /costs?bookId= → { costs: [...] }
  listForBooking(bookId) { return this.get(`/?bookId=${encodeURIComponent(bookId)}`); }

  // POST /costs { bookId, costs: [...] } — every line from the modal at once.
  log(bookId, costs) { return this.post('/', { body: { bookId, costs } }); }

  verify(idCost) { return this.put(`/${idCost}/verify`); }
}

export const CostsService = new CostsAPI();
export default CostsAPI;
